import { GenericAPIError } from './generic-error';

export class RecaptchaError extends GenericAPIError {
  constructor() {
    super('Recaptcha returned some error');
    this.name = 'RecaptchaError';
  }
}
